// extracted by mini-css-extract-plugin
export default {"nfLoader":"styles_nfLoader__SpPFT","nfLoader-spin":"styles_nfLoader-spin__5l8RQ"};